import { useGetTicketContactsQuery } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.hooks';
import { getIsPreview } from '../utils/isPreview';
import { getPortalAccountId, getPortalInstanceId } from 'portals-platform-lib';
export const useTicketContacts = ticketId => {
  const {
    isPreview
  } = getIsPreview();
  return useGetTicketContactsQuery({
    variables: {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId(),
      params: {
        ticketId
      }
    },
    skip: !ticketId || isPreview
  });
};